export const texts = {
    notAuthenticated: "Please login first",
    listingFilterCantBeLoaded: "Listing filters can't be loaded",
    somethingWentWrong: "Something went wrong"
}
